import { useRouter } from 'next/router'
import { ParsedUrlQuery } from 'querystring'
import styled from 'styled-components'

function Pagination( { pageCount } ) {
  const router = useRouter()
  const page = parseInt( router.query.page as string || '1', 10 )

  if ( !router.isReady ) {
    return null
  }

  const pageButtonsStart = Math.max( Math.min( page - 2, pageCount - 5 ), 1 )
  const pageButtonsEnd = Math.min( pageButtonsStart + 4, pageCount )
  const pageButtons = []

  if ( pageButtonsStart > 1 ) {
    pageButtons.push( 1 )
  }

  if ( pageButtonsStart > 2 ) {
    pageButtons.push( '…' )
  }

  for ( let i = pageButtonsStart; i <= pageButtonsEnd; i += 1 ) {
    pageButtons.push( i )
  }

  if ( pageButtonsEnd < pageCount - 1 ) {
    pageButtons.push( '…' )
  }
  
  if ( pageButtonsEnd < pageCount ) {
    pageButtons.push( pageCount )
  }

  const gotoPage = newPage => {
    if ( newPage === 1 ) {
      const queryClone: ParsedUrlQuery = { ...router.query }
      delete queryClone.page

      router.push( {
        pathname: router.pathname,
        query: { ...queryClone },
      } )

      return
    }

    router.push( {
      pathname: router.pathname,
      query: { ...router.query, page: newPage },
    } )
  }

  return (
    <StyledPagination>
      { pageButtons.map( ( btn, i ) => {
        if ( btn !== parseInt( btn, 10 ) ) {
          // eslint-disable-next-line react/no-array-index-key
          return <span key={ i }>{ btn }</span>
        }

        return (
          <button
            // eslint-disable-next-line react/no-array-index-key
            key={ i }
            type="button"
            disabled={ page === btn }
            onClick={ () => gotoPage( btn ) }
          >
            { btn }
          </button>
        )
      } ) }
    </StyledPagination>
  )
}

const StyledPagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  button,
  span {
    display: block;
    padding: 0.5rem 0;
    margin: 0 0.25rem;
    width: 30px;
    text-align: center;
  }

  button {
    background: 0;
    border: 0;
    border-bottom: 1px solid ${ p => p.theme.colors.blueGrey__mid };
    ${ p => p.theme.typo.generalSans };
    transition: background-color .3s ease-out;

    :disabled {
      border-color: ${ p => p.theme.colors.red };
    }

    :not( :disabled ):hover {
      background: ${ p => p.theme.colors.blueGrey__superlight };
    }
  }
`

export default Pagination
